<template>
  <div>
    <b-modal
      v-model="show"
      id="modal-logout"
      ref="modal-logout"
      title="Logout Form"
    >

      <div class="d-block text-center">
        <h3>Are you sure <br>you want to log out now !</h3>
      </div>

      <template slot="modal-footer">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button
          size="sm"
          type="submit"
          variant="success"
          @click="SignOut"
        >
          Ok
        </b-button>
        <b-button
          size="sm"
          variant="danger"
          @click="show= false"
        >
          Cancel
        </b-button>
      </template>

    </b-modal>
  </div>
</template>

<script>
import { Component, Vue, options } from "vue-property-decorator";
import store from "@/store/store";
import axios from "axios";
import VueAxios from "vue-axios";
import Login from "@/components/Login";
import VueSession from "vue-session";

Vue.use(VueSession);

@Component({
  component: {
    store,
    axios,
    VueAxios
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    SignOut() {
      let currentObj = this;
      store.set("systems@LoginStatus", false);
      store.set("systems@LoginData", []);
      store.set("systems@ApiKey", "");
      this.$session.destroy();
      currentObj.show = false;
    }
  }
})
export default class Logut extends Vue {}
</script>

<style lang="scss">
.alert {
  margin-bottom: 0px !important;
}
</style>

